import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionMessage from "@atlaskit/section-message";
import { getBaseURL } from "../env/stage";

import { getBackupToken } from "../redux/actions/backupRestoreActions";
const RestoreFlowAPI = () => {
  const dispatch = useDispatch();
  const backupToken = useSelector((state) => state.backups.backupToken);

  useEffect(() => {
    dispatch(getBackupToken());
  }, []);

  return (
    <>
      <SectionMessage title="Tip.">
        To authenticate the request, include a query parameter with the backup token like this:
        <br />
        <b>?token={backupToken?.token}</b>
        <br />
        In the request body, include the flow data payload you want to submit.
      </SectionMessage>
      <div style={{ maxWidth: "100%" }}>
        <strong>Full URL:</strong>{" "}
        <code
          style={{
            display: "block",
            whiteSpace: "normal",
            wordBreak: "break-all",
            overflowWrap: "anywhere",
          }}
        >
          {getBaseURL()}/backup/api?token={backupToken?.token}
        </code>
      </div>
    </>
  );
};

export default RestoreFlowAPI;
